export interface GisCoordinateResponse {
  id: number;
  name: string;
  wkid: string;
  areaOfUse: string;
  minLatitude: string;
  minLongitude: string;
  maxLatitude: string;
  maxLongitude: string;
}

export const emptyGisCoordinateResponse: GisCoordinateResponse = {
  id: 0,
  name: "",
  wkid: "",
  areaOfUse: "",
  minLatitude: "",
  minLongitude: "",
  maxLatitude: "",
  maxLongitude: "",
};
